
export function removeLayout(Page) {
    Page.getLayout = page => page
}